import React from 'react';
import UserAvatar from 'layouts/main/userAvatar/UserAvatar'
import { Col, Row } from 'react-bootstrap';
import AuditDetail from './AuditDetail'
import * as Formatting from 'fw/misc/Formatting'
import * as AuditFormat from './AuditFormat'

class AuditRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            detailVisible: true
        }
    }

    render() {
        return (
            <div key={this.props.auditId} onClick={() => this.onClick()}>
                <Row>
                    <Col md={12}>
                        <div style={{ float: "left", paddingRight: 5 }}>
                            <UserAvatar userId={this.props.auditItem.userId} small={true} />
                        </div>
                        <strong>{this.props.auditItem.userName}</strong> -&nbsp;
                        {Formatting.formatClientDateTime(this.props.auditItem.date)}
                        <br />
                        {AuditFormat.formatText(this.props.auditItem.description)}
                    </Col>
                </Row>
                {this.state.detailVisible && this.props.auditItem.changeList != null && 
                    <AuditDetail changeList={this.props.auditItem.changeList} />
                }
            </div>
        )
    }

    onClick() {
        this.setState({ detailVisible: !this.state.detailVisible });
    }

}

export default AuditRow;




// WEBPACK FOOTER //
// ./src/areas/shared/components/audit/AuditRow.js